document.addEventListener("DOMContentLoaded", () => {
  const canvas = document.getElementById("lc-scroll-canvas");
  const context = canvas.getContext("2d");
  const container = canvas.parentElement;

  const imageUrls = [
    "https://lvlup.lightcraft.com.au/assets/6be22ec1-5f92-4dff-a021-240448fe3a30.webp",
    "https://lvlup.lightcraft.com.au/assets/1d06f58f-5050-4408-97af-92afc6042d5c.webp",
    "https://lvlup.lightcraft.com.au/assets/e9191ffc-87f8-47a3-bcb3-c4eb690882e6.webp",
    "https://lvlup.lightcraft.com.au/assets/7c474f07-e532-4fc3-89e0-0f3aa03a89be.webp",
    "https://lvlup.lightcraft.com.au/assets/98af54eb-584d-4668-8abd-9fcebcb074f0.webp",
    "https://lvlup.lightcraft.com.au/assets/1befcae6-55a1-43ca-b371-5b2a7eae9831.webp",
    "https://lvlup.lightcraft.com.au/assets/5aac3951-98d3-4e09-adcc-5e01de8d001c.webp",
    "https://lvlup.lightcraft.com.au/assets/fd7b9a55-055f-4e4d-97bc-ff3d13ed672a.webp",
    "https://lvlup.lightcraft.com.au/assets/1d14ac8e-4442-495c-837d-c0f1af84af41.webp",
    "https://lvlup.lightcraft.com.au/assets/e982da2a-3d93-4858-8703-62841e03a05f.webp",
    "https://lvlup.lightcraft.com.au/assets/5edaf85e-1a31-4794-b6b6-d5fbad1fe3a3.webp",
    "https://lvlup.lightcraft.com.au/assets/bf33b542-d6ad-4e1b-a9ab-06598cc6e5b7.webp",
    "https://lvlup.lightcraft.com.au/assets/201b42b5-bebe-473b-b611-efe8d7733523.webp",
    "https://lvlup.lightcraft.com.au/assets/ec283ab8-1f02-4c31-95d3-a570e6821563.webp",
    "https://lvlup.lightcraft.com.au/assets/1c72ff36-c906-4d3c-b78f-63a16ef9d8c9.webp",
    "https://lvlup.lightcraft.com.au/assets/95eb29e9-15a6-409b-8256-8d0f06f41e12.webp",
    "https://lvlup.lightcraft.com.au/assets/2f8cd4d7-7bcb-4370-8820-d517aaac8ca7.webp",
    "https://lvlup.lightcraft.com.au/assets/23b65fdf-4d4c-42b9-adc7-7afe2d9aca13.webp"
  ];
  const totalFrames = imageUrls.length;
  const images = [];
  let imagesLoaded = 0;
  let currentFrameIndex = -1;

  // Defer image loading until after page content has fully loaded
  window.addEventListener("load", () => {
    // Load images in batches to avoid overwhelming the browser
    const batchSize = 5; // Adjust the batch size as needed
    let currentBatchIndex = 0;

    const loadNextBatch = () => {
      const start = currentBatchIndex * batchSize;
      const end = Math.min(start + batchSize, totalFrames);

      for (let i = start; i < end; i++) {
        const img = new Image();
        img.src = imageUrls[i];
        images[i] = img; // Store the image at its index

        img.onload = () => {
          imagesLoaded++;
          if (imagesLoaded === totalFrames) {
            // All images are loaded, start initial frame render
            resizeCanvas();
            updateFrame();
          }
        };
      }

      currentBatchIndex++;
      if (currentBatchIndex * batchSize < totalFrames) {
        // Load the next batch after a short delay
        setTimeout(loadNextBatch, 100);
      }
    };

    // Start loading the first batch
    loadNextBatch();
  });

  // Resize canvas to match container dimensions, throttled to improve performance
  const resizeCanvas = () => {
    canvas.width = container.offsetWidth;
    canvas.height = container.offsetHeight;
  };

  let resizeTimeout;
  const throttleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      resizeCanvas();
      updateFrame(); // Update frame after resizing
    }, 100);
  };
  window.addEventListener("resize", throttleResize);

  // Update frame based on scroll position
  const updateFrame = () => {
    const rect = container.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const containerHeight = rect.height;
    const halfFrames = Math.floor(totalFrames / 2);

    let frameIndex = -1;

    // First Phase: rect.top entering viewport to rect.bottom entering viewport
    if (
      rect.top <= windowHeight &&
      rect.bottom >= windowHeight &&
      rect.top >= 0
    ) {
      const progress = (windowHeight - rect.top) / containerHeight;

      // Calculate frame index for the first half
      frameIndex = Math.min(
        halfFrames - 1,
        Math.floor(progress * halfFrames)
      );
    }
    // Second Phase: rect.top leaving viewport to rect.bottom leaving viewport
    else if (
      rect.top <= 0 &&
      rect.bottom >= 0 &&
      rect.bottom <= windowHeight
    ) {
      const progress = (0 - rect.top) / containerHeight;

      // Calculate frame index for the second half
      frameIndex =
        halfFrames +
        Math.min(halfFrames - 1, Math.floor(progress * halfFrames));
    }
    // When the container is fully visible
    else if (rect.top >= 0 && rect.bottom <= windowHeight) {
      // Display the last frame of the first half
      frameIndex = halfFrames - 1;
    }
    // Outside of animation phases
    else {
      frameIndex = -1;
    }

    // Only update if the frame index has changed and the image is loaded
    if (
      frameIndex !== -1 &&
      frameIndex !== currentFrameIndex &&
      images[frameIndex]?.complete
    ) {
      currentFrameIndex = frameIndex;
      context.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas
      context.drawImage(
        images[frameIndex],
        0,
        0,
        canvas.width,
        canvas.height
      );
    }
  };

  // Debounce implementation using requestAnimationFrame for optimal performance
  let isUpdating = false;

  const debouncedUpdateFrame = () => {
    if (!isUpdating) {
      isUpdating = true;
      requestAnimationFrame(() => {
        updateFrame();
        isUpdating = false;
      });
    }
  };

  // Listen for scroll and touch events
  window.addEventListener("scroll", debouncedUpdateFrame);
  window.addEventListener("touchmove", debouncedUpdateFrame);
});
